import { Routes } from '@angular/router';
import { provideState } from '@ngrx/store';
import { loginFeature } from '~login/store/login.reducer';
import { provideEffects } from '@ngrx/effects';
import * as LoginEffects  from '~login/store/login.effects';
import { AuthGuard } from './core/guards/auth.guard';
import { statusFeature } from '~status/store/status.reducer';
import * as statusEffects from '~status/store/status.effects';
import { MoveDeviceFeature } from '~move-device/store/move-device.reducer';
import * as moveDeviceEffects from '~move-device/store/move-device.effects';

export const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('~login/login.routes'),
        providers: [provideState(loginFeature), provideEffects(LoginEffects)],
    },
    {
        path: 'status',
        loadChildren: () => import('~status/status.routes'),
        canActivate: [AuthGuard],
        providers: [provideState(statusFeature), provideEffects(statusEffects)]
    },
    {
        path: 'move-device',
        loadChildren: () => import('~move-device/move-device.routes'),
        canActivate: [AuthGuard],
        providers: [provideState(MoveDeviceFeature), provideEffects(moveDeviceEffects)]
    },
    {
        path: '**',
        redirectTo: 'login',
    },
];
